module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH5AcQCg4BRyvgdQAAAO9JREFUWMPt2MFNw0AURdE7k5GSSIDcAR3YVpIKEJVQGJUgpgHbSlJBXEASKyCPIxk+G2bPJowX/1ZwFm/1DEDXdU9f8v263+4eSVBeFu3M2Jcsy97NL+Ztv92Z1WbNcr7AOYcx5qYIEWEcR8J1oKlq8rKQmbHPHM+ng/de+tBLqvrQi/dejufTwXjvZbVZ83B3T8ounx80VY0FWM4XpC4aLIBzLjkoGixw8wH/pWiwTCwFKUhBClKQghSkIAUpSEEK+geQiCSHRIMFGMcxOSgaLEC4DslB0WDzsmibqiYMIR1mCPEjaid3WBmY1qX3A4Oc/DA/+4ulAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/png/checkbox-unchecked.png
// module id = P+02
// module chunks = 0